import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NoRecordComponent } from './no-record/no-record.component';

@NgModule({
  declarations: [NoRecordComponent],
  imports: [CommonModule, TranslateModule.forChild()],
  exports: [NoRecordComponent],
})
export class SharedComponentsModule {}
